<template>
    <div>
        <el-form :model="transVoucherInfo" ref="ruleForm" :rules="rules" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center" v-if="!lowCostFlag && !crossFlag && !autoInFiscal">
                    <div class="form-label"></div>
                    <div class="form-value">
                        <el-checkbox v-model="transVoucherInfo.autoFiscalIn">自动入账</el-checkbox>
                    </div>
                </div>
                <div class="form-group center" v-if="principalId != null && !crossFlag">
                    <div class="form-label"></div>
                    <div class="form-value">
                        <el-checkbox v-model="transVoucherInfo.autoReceive">机构负责人自动领用</el-checkbox>
                    </div>
                </div>
            </div>
        </el-form>

        <el-tabs v-model="deviceActiveName" @tab-click="deviceHandleClick" v-show="!transVoucherInfo.suitFlag">
            <el-tab-pane label="单品式管理" name="device">
                <div class="table-layout">
                    <el-table :data="devcDefSingleList" border style="width: 100%" :expand-row-keys="expends" :row-key="getRowKeys" :row-class-name="getRowClass" @expand-change="showManageDetail">
                        <el-table-column type="expand">
                            <template slot-scope="rows">
                                <div class="sub-table-layout pl10 pr10">
                                    <el-table :data="rows.row.singleDeviceList" border style="width: 100%">
                                        <el-table-column prop="batchNo" label="批次号" align="left"></el-table-column>
                                        <el-table-column prop="innerCode" label="资产编号" align="left"></el-table-column>
                                        <el-table-column prop="title" label="资产描述全称"></el-table-column>
                                        <el-table-column prop="tmpNo" label="系统编号" align="left"></el-table-column>
                                        <el-table-column prop="vendorUkno" label="商品标识码" align="left"></el-table-column>
                                        <el-table-column prop="createTime" label="创建时间" width="140" align="center"></el-table-column>
                                        <el-table-column prop="allotAcntType" label="核算类型" width="140" align="center">
                                            <template slot-scope="scope">
                                                <span>{{allotAcntTypeMap[scope.row.allotAcntType]}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="dstComName" label="调入部门" width="140">
                                            <template slot-scope="scope">
                                                <span align="left" v-if="scope.row.dstComName != null">{{scope.row.dstComName}}</span>
                                                <a class="swb-btn-link" align="right" @click="selectDstComName(scope.$index, rows.$index)">选择部门</a>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="dstWarehouseName" label="调入仓库" width="140" align="center">
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.dstWarehouseId" placeholder="请选择" @change="selectDstWarehouse(scope.$index, rows.$index)">
                                                    <el-option v-for="item in dstWarehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="定义名称" prop="name"></el-table-column>
                        <el-table-column label="资产描述全称" prop="title"></el-table-column>
                        <el-table-column label="型号" prop="model"></el-table-column>
                        <el-table-column label="规格" prop="fixedSpec"></el-table-column>
                        <el-table-column label="分类" prop="catName"></el-table-column>
                        <el-table-column label="分类分组">
                            <template slot-scope="rows">
                                <span>{{getGoodsCatDevcGroupName(rows.row.catId)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="品牌" prop="brandName"></el-table-column>
                        <el-table-column label="单位" prop="theUnit"></el-table-column>
                        <el-table-column label="核算方法" prop="allotAcntMethod">
                            <template slot-scope="rows">
                                <span>{{allotAcntMethodMap[rows.row.allotAcntMethod]}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="批量式管理" name="durable">
                <div class="table-layout">
                    <el-table :data="devcDefDurableList" border style="width: 100%" :expand-row-keys="batchExpends" :row-key="getRowKeys" :row-class-name="getBatchRowClass" @expand-change="showBatchManageDetail">
                        <el-table-column type="expand">
                            <template slot-scope="rows">
                                <div class="sub-table-layout pl10 pr10">
                                    <el-table :data="rows.row.devcBatchList" border style="width: 100%">
                                        <el-table-column prop="batchNo" label="批次号" width="180"></el-table-column>
                                        <el-table-column prop="innerCode" label="资产编号" width="180"></el-table-column>
                                        <el-table-column prop="title" label="资产描述全称"></el-table-column>
                                        <el-table-column prop="inStkQuantity" label="在库数量" align="left"></el-table-column>
                                        <el-table-column prop="transQuantity" label="可调拨数量" align="right" width="80"></el-table-column>
                                        <el-table-column prop="fiscalQuantity" label="财务在账数量" align="right" width="100"></el-table-column>
                                        <el-table-column prop="scrappedQuantity" label="报废数量" align="right" width="100" v-if="transVoucherInfo.fiscalAcctFlag"></el-table-column>
                                        <el-table-column prop="dstComName" label="调入部门" width="140">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.dstComName" @change="selectDoubleDstComName(scope.$index, rows.$index)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="dstWarehouseName" label="调入仓库" width="140" align="center">
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.dstWarehouseId" placeholder="请选择" @change="selectDoubleDstWarehouse(scope.$index, rows.$index)">
                                                    <el-option v-for="item in dstWarehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="quantity" label="调拨数量" width="100" align="right">
                                            <template slot-scope="scope">
                                                <div v-if="rows.row.stockFifo">
                                                    <el-input :disabled="!(rows.row.devcBatchList != null && rows.row.devcBatchList.length-1 == scope.$index)" type="number" v-model="scope.row.quantity" @change="setQuantity(scope.$index, rows.$index)"></el-input>
                                                </div>
                                                <el-input type="number" v-else v-model="scope.row.quantity" @change="setQuantity(scope.$index, rows.$index)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="quantity2" label="含报废数量" width="100" align="right" v-if="transVoucherInfo.fiscalAcctFlag">
                                            <template slot-scope="scope">
                                                <div v-if="rows.row.stockFifo">
                                                    <el-input :disabled="!(rows.row.devcBatchList != null && rows.row.devcBatchList.length-1 == scope.$index)" type="number" v-model="scope.row.quantity2" @change="setQuantity2(scope.$index, rows.$index)"></el-input>
                                                </div>
                                                <el-input type="number" v-else v-model="scope.row.quantity2" @change="setQuantity2(scope.$index, rows.$index)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="createTime" label="创建时间" width="140" align="center"></el-table-column>
                                    </el-table>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="定义名称" prop="name"></el-table-column>
                        <el-table-column label="资产描述全称" prop="title"></el-table-column>
                        <el-table-column label="型号" prop="model"></el-table-column>
                        <el-table-column label="规格" prop="fixedSpec"></el-table-column>
                        <el-table-column label="分类" prop="catName"></el-table-column>
                        <el-table-column label="分类分组">
                            <template slot-scope="rows">
                                <span>{{getGoodsCatDevcGroupName(rows.row.catId)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="品牌" prop="brandName"></el-table-column>
                        <el-table-column label="单位" prop="theUnit"></el-table-column>
                        <el-table-column label="核算方法" prop="allotAcntMethod">
                            <template slot-scope="rows">
                                <span>{{allotAcntMethodMap[rows.row.allotAcntMethod]}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div v-if="showSuitList" v-show="transVoucherInfo.suitFlag">
            <swb-shop-device-suit-stock-trans-item-select :suitFlag="transVoucherInfo.suitFlag" :dstWarehouseId="transVoucherInfo.srcBizUnitId" :deviceItemList="transVoucherInfo.deviceItemList" :dstBizUnitId="transVoucherInfo.dstBizUnitId" :srcComId="transVoucherInfo.srcComId" ref="item_device_suit_select"></swb-shop-device-suit-stock-trans-item-select>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">确认描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input class="textarea-value" type="textarea" v-model="transVoucherInfo.confirmerDesc"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getMerchantBizParam } from '../asset/assetMain'
    import { getDevcGroupNameByCatId } from '../index';
    import { openBizDepartDlg } from '../orgStruct/selectDlg'

    import shopStockApi from '../../api/shopStock'
    import retailerApi from '../../api/retailer'
    import assetVchrApi from '../../api/assetVchr'

    export default {
        name: 'swb-shop-device-trans-voucher-confirm',
        desc: '调拨单确认',
        props: {
            id: {
                type: Number,
                default: null,
            },
            crossFlag: {
                type: Boolean,
                default: false
            },
            crossComFlag: {
                type: Boolean,
                default: false
            },
            srcWarehouseId: {
                type: Number,
                default: null,
            },
            dstWarehouseId: {
                type: Number,
                default: null,
            },
            lowCostFlag: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            let self = this;
            let validateWarehouseId = function (rule, value, callback) {
                if(Utils.isNoB(self.ruleForm.dstWarehouseId)) {
                    callback(new Error('请选择仓库'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    dstWarehouseId: null,
                    confirmState: 1,
                },
                currTransComFlag: false,
                // 调入机构仓库
                dstWarehouseList: [],
                rules: {
                    dstWarehouseId: [{
                        validator: validateWarehouseId,
                        trigger: 'blur'
                    }],
                },
                transVoucherInfo: {},
                autoFiscalIn: false,
                autoReceive: false,
                principalId: null,
                autoInFiscal: false,
                devcDefSingleList: [],
                devcDefDurableList: [],
                deviceActiveName: 'device',
                expends: [],
                batchExpends: [],
                allotAcntTypeMap: getEnumMap("allotAcntType", "value2text"),
                allotAcntMethodMap: getEnumMap("allotAcntMethod", "value2text"),
                showSuitList: false,
            }
        },
        created: function () {
            this.ruleForm.dstWarehouseId = this.dstWarehouseId;
            this.currentComId = this.dstComId;
            this.currentComName = this.dstComName;
            //
            this.currTransComFlag = this.crossComFlag;      // 是否跨机构调拨
            //
            let self = this;
            if(Utils.isFalse(self.lowCostFlag)) {
                this.getShopDeviceTransVoucher();
            } else {
                this.getWarehouseList();
                this.getRetailerCom();
            }
        },
        methods: {
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getRowKeys(row){
                return row.id
            },
            getBatchRowClass(row, rowIndex){
                let devcBatchList = row.row.devcBatchList || [];
                if(devcBatchList.length == 0) {  //判断当前行是否有子数据或者根据实际情况设置
                    return 'row-expand-cover'
                }
            },
            getRowClass(row, rowIndex){
                let singleDeviceList = row.row.singleDeviceList || [];
                if(singleDeviceList.length == 0) {  //判断当前行是否有子数据或者根据实际情况设置
                    return 'row-expand-cover'
                }
            },
            deviceHandleClick(){
                // 切换页签 - 清除已选择资产
                if(this.deviceActiveName == 'device') {
                    //
                } else if(this.deviceActiveName == 'durable') {
                    //
                }
            },
            showManageDetail(row){
                let id = row.id;
                let expends = this.expends || [];
                if(expends.indexOf(id) > -1) {
                    expends.remove(id);
                } else {
                    expends.push(id);
                }
                this.expends = Utils.merge([], expends);
            },
            showBatchManageDetail(row){
                let id = row.id;
                let batchExpends = this.batchExpends || [];
                if(batchExpends.indexOf(id) > -1) {
                    batchExpends.remove(id);
                } else {
                    batchExpends.push(id);
                }
                this.batchExpends = Utils.merge([], batchExpends);
            },
            getAllotAcntType: function (item, callBack) {
                let theLoad = MsgBox.loading();
                let self = this;
                let postData = {
                    dstComId: item.dstComId,
                    srcComId: item.srcComId
                };
                assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        callBack(result.data)
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopDeviceTransVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceTransVoucherById(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let expends = self.expends || [];
                        //
                        let transVoucherInfo = result.data;
                        let comId = null;
                        let comName = null;
                        self.getRetailerComInfo(transVoucherInfo.dstBizUnitId, function (comResult) {
                            comId = comResult.id;
                            comName = comResult.name;
                        });
                        let merchtDevcDefList = transVoucherInfo.merchtDevcDefList || [];
                        let devcDefSingleList = self.devcDefSingleList || [];
                        let devcDefDurableList = self.devcDefDurableList || [];
                        for(let i = 0; i < merchtDevcDefList.length; i++) {
                            let merchtDevcDef = merchtDevcDefList[i];
                            let transAssetList = merchtDevcDef.transAssetList || [];
                            if(transAssetList.length > 0) {
                                let singleDeviceList = [];
                                let devcBatchList = [];
                                for(let j = 0; j < transAssetList.length; j++) {
                                    let item = transAssetList[j];
                                    if(Utils.isNoB(item.dstComId)) {
                                        item.dstComId = comId;
                                        item.dstComName = comName;
                                    }
                                    if(merchtDevcDef.assetType == 0) {
                                        singleDeviceList.push(item);
                                    } else {
                                        devcBatchList.push(item);
                                    }
                                    merchtDevcDef.devcDefItemId = item.devcDefItemId;
                                }
                                if(merchtDevcDef.assetType == 0) {
                                    merchtDevcDef.singleDeviceList = Utils.merge([], singleDeviceList);
                                    devcDefSingleList.push(merchtDevcDef);
                                } else {
                                    merchtDevcDef.devcBatchList = Utils.merge([], devcBatchList);
                                    devcDefDurableList.push(merchtDevcDef);
                                }
                                // 自动展开
                                if(expends.indexOf(merchtDevcDef.id) < 0) {
                                    expends.push(merchtDevcDef.id)
                                }
                            }
                        }
                        if(transVoucherInfo.suitFlag) {
                            let deviceItemList = transVoucherInfo.deviceItemList || [];
                            deviceItemList.forEach(function (item) {
                                if(Utils.isNoB(item.dstComId)) {
                                    item.dstComId = comId;
                                    item.dstComName = comName;
                                }
                            });
                            self.showSuitList = true;
                        }
                        self.expends = Utils.merge([], expends);
                        self.devcDefSingleList = Utils.merge([], devcDefSingleList);
                        self.devcDefDurableList = Utils.merge([], devcDefDurableList);
                        self.crossFlag = transVoucherInfo.crossFlag;
                        //
                        self.getWarehouseList(transVoucherInfo.dstBizUnitId);
                        self.transVoucherInfo = transVoucherInfo;
                        getMerchantBizParam("asset.finac.enabled", function (resultEnabled) {
                            getMerchantBizParam("auto.fiscal.in.after.receipt.invoice.confirmed", function (resultConfirmed) {
                                self.autoInFiscal = Utils.isTrue(resultEnabled) && Utils.isTrue(resultConfirmed);
                            });
                        }, 2, transVoucherInfo.dstBizUnitId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getRetailerComInfo(id, callBack){
                retailerApi.getRetailerCom({id: id}, function (result) {
                    if(result.type == 'info') {
                        callBack(result.data);
                    }
                });
            },
            getRetailerCom(){
                let self = this;
                retailerApi.getRetailerCom({}, function (result) {
                    if(result.type == 'info') {
                        self.principalId = result.data.principalId;
                    }
                });
            },
            // 仓库信息
            getWarehouseList: function (dstBizUnitId) {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.retailerShopId = dstBizUnitId;
                filterItems.locked = false;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let dstWarehouseList = result.data;
                        if(self.crossComFlag) {
                            dstWarehouseList.forEach(function (row) {
                                if(row.defaulted == true) {
                                    self.ruleForm.dstWarehouseId = row.id;
                                }
                            })
                        }
                        self.dstWarehouseList = dstWarehouseList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let transVoucherInfo = self.transVoucherInfo;
                let deviceItemList = [];
                let durableItemList = [];
                if(transVoucherInfo.suitFlag) {// 套装资产
                    //
                    let deviceResult = self.$refs.item_device_suit_select.getResult() || {};
                    deviceItemList = deviceResult.data || [];
                } else {
                    let devcDefSingleList = self.devcDefSingleList || [];
                    let devcDefDurableList = self.devcDefDurableList || [];
                    if(devcDefSingleList.length > 0) {
                        for(let i = 0; i < devcDefSingleList.length; i++) {
                            if(!Utils.isNoB(devcDefSingleList[i].singleDeviceList) && devcDefSingleList[i].singleDeviceList.length > 0) {
                                deviceItemList = deviceItemList.concat(devcDefSingleList[i].singleDeviceList);
                            }
                        }
                    }
                    // 批量资产
                    if(devcDefDurableList.length > 0) {
                        for(let i = 0; i < devcDefDurableList.length; i++) {
                            if(!Utils.isNoB(devcDefDurableList[i].devcBatchList) && devcDefDurableList[i].devcBatchList.length > 0) {
                                durableItemList = durableItemList.concat(devcDefDurableList[i].devcBatchList);
                            }
                        }
                    }
                }
                let warnFlag = false;
                let message = "";
                let itemList = deviceItemList.concat(durableItemList);
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(Utils.isNoB(item.dstWarehouseId)) {
                        message = "【" + item.title + "】调入仓库不能为空";
                        warnFlag = true;
                        break;
                    }
                    if(Utils.isNoB(item.dstComId)) {
                        message = "【" + item.title + "】调入部门不能为空";
                        warnFlag = true;
                        break;
                    }
                    if(item.srcWarehouseId == item.dstWarehouseId && item.srcComId == item.dstComId) {
                        message = "【" + item.title + "】调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨";
                        warnFlag = true;
                        break;
                    }
                }

                if(warnFlag) {
                    result.type = "warn";
                    result.message = message;
                } else {
                    let confirmVoucherInfo = {};
                    confirmVoucherInfo.id = self.id;
                    confirmVoucherInfo.autoFiscalIn = transVoucherInfo.autoFiscalIn || false;
                    confirmVoucherInfo.autoReceive = transVoucherInfo.autoReceive || false;
                    confirmVoucherInfo.confirmState = 1;
                    confirmVoucherInfo.itemList = itemList;
                    result.type = "info";
                    result.data = confirmVoucherInfo;
                }
                return result;
            },
            selectDstComName: function (rowIndex, index) {
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let devcDefSingleList = self.devcDefSingleList;
                let devcDefInfo = devcDefSingleList[index];
                let singleDeviceList = devcDefInfo.singleDeviceList;
                let deviceInfo = singleDeviceList[rowIndex];

                openBizDepartDlg(transVoucherInfo.dstBizUnitId, function (result) {
                    deviceInfo.dstComId = result.id;
                    deviceInfo.dstComName = result.name;
                    //
                    if(deviceInfo.srcWarehouseId == deviceInfo.dstWarehouseId && deviceInfo.srcComId == deviceInfo.dstComId) {
                        MsgBox.warning("调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨");
                        return false;
                    }
                    self.getAllotAcntType(deviceInfo, function (result) {
                        deviceInfo.allotAcntType = result;
                        devcDefInfo.singleDeviceList = Utils.merge([], singleDeviceList);
                        self.devcDefSingleList = Utils.merge([], devcDefSingleList);
                    });
                });
            },
            selectDstWarehouse(rowIndex, index){
                let self = this;
                let devcDefSingleList = self.devcDefSingleList;
                let devcDefInfo = devcDefSingleList[index];
                let singleDeviceList = devcDefInfo.singleDeviceList;
                let deviceInfo = singleDeviceList[rowIndex];
                if(deviceInfo.srcWarehouseId == deviceInfo.dstWarehouseId && deviceInfo.srcComId == deviceInfo.dstComId) {
                    MsgBox.warning("调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨");
                    return false;
                } else {
                    let dstWarehouseId = deviceInfo.dstWarehouseId;
                    let dstWarehouseList = this.dstWarehouseList;
                    let wareHouse = dstWarehouseList.find(function (item) {
                        return item.id == dstWarehouseId;
                    });
                    deviceInfo.dstWarehouseName = wareHouse.name;
                    devcDefInfo.singleDeviceList = Utils.merge([], singleDeviceList);
                    self.devcDefSingleList = Utils.merge([], devcDefSingleList);
                }
            },
            selectDoubleDstComName: function (rowIndex, index) {
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let devcDefDurableList = self.devcDefDurableList;
                let devcDefInfo = devcDefDurableList[index];
                let devcBatchList = devcDefInfo.devcBatchList;
                let deviceInfo = devcBatchList[rowIndex];

                openBizDepartDlg(transVoucherInfo.dstBizUnitId, function (result) {
                    deviceInfo.dstComId = result.id;
                    deviceInfo.dstComName = result.name;
                    //
                    if(deviceInfo.srcWarehouseId == deviceInfo.dstWarehouseId && deviceInfo.srcComId == deviceInfo.dstComId) {
                        MsgBox.warning("调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨");
                        return false;
                    }
                    self.getAllotAcntType(deviceInfo, function (result) {
                        deviceInfo.allotAcntType = result;
                        devcDefInfo.devcBatchList = Utils.merge([], devcBatchList);
                        self.devcDefDurableList = Utils.merge([], devcDefDurableList);
                    });
                });
            },
            selectDoubleDstWarehouse(rowIndex, index){
                let self = this;
                let devcDefDurableList = self.devcDefDurableList;
                let devcDefInfo = devcDefDurableList[index];
                let devcBatchList = devcDefInfo.devcBatchList;
                let devcBatch = devcBatchList[rowIndex];
                if(devcBatch.srcWarehouseId == devcBatch.dstWarehouseId && devcBatch.srcComId == devcBatch.dstComId) {
                    MsgBox.warning("调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨");
                    return false;
                } else {
                    let dstWarehouseId = devcBatch.dstWarehouseId;
                    let dstWarehouseList = this.dstWarehouseList;
                    let wareHouse = dstWarehouseList.find(function (item) {
                        return item.id == dstWarehouseId;
                    });
                    devcBatch.dstWarehouseName = wareHouse.name;
                    devcDefInfo.devcBatchList = Utils.merge([], devcBatchList);
                    self.devcDefDurableList = Utils.merge([], devcDefDurableList);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherConfirm.vue